import { fromJS } from 'immutable'
import _get from 'lodash/get'
import _set from 'lodash/set'
import _map from 'lodash/map'
import { parseISO } from 'date-fns'
import request from '../../request'
import { formatWrapped } from '../../date'
import { createAuthorization } from '../../auth'
import { CONTENT_SET_LABELS } from '../../../gui/components/user-management/UserDetailForm/UserEntitlements/UserEntitlement/ContentSetIdSelect'

const dateTimeFormat = 'yyyy-MM-dd HH:mm:ss'

export async function getUserHistory (options = {}) {
  const { server, auth, body } = options
  const res = await request
    .post(`${server}/v1/audit/search`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .send(body)
  return fromJS(transformUserHistoryData({ data: _get(res, 'body', null) }))
}

export function transformUserHistoryData (options = {}) {
  const { data } = options
  if (data) {
    const records = _get(data, 'records', [])
    const newRecords = _map(records, (record) => {
      const fieldName = _get(record, 'fieldName')
      if (fieldName === 'Entitlement Change' || fieldName === 'Entitlement Add') {
        _set(record, 'newValue', getFormattedValue(_get(record, 'newValue')))
        _set(record, 'previousValue', getFormattedValue(_get(record, 'previousValue')))
      }

      _set(
        record,
        'createdAt',
        `${formatWrapped(parseISO(_get(record, 'createdAt')), dateTimeFormat)}`,
      )
      _set(record, 'effectiveDate', getFormattedDateInUTC(parseISO(_get(record, 'effectiveDate'))))
      if (fieldName === 'Hold') {
        _set(record, 'fieldName', 'Pause')
      }
      return record
    })
    return {
      records: newRecords,
      success: _get(data, 'success'),
      page: _get(data, 'page'),
      count: _get(data, 'count'),
      perPage: _get(data, 'perPage'),
      isLastPage: isLastPage({ data }),
    }
  }
  return null
}

function isLastPage (options = {}) {
  const { data } = options
  const { count, perPage, page } = data
  return Math.ceil(count / perPage) - 1 === page
}

function getFormattedValue (value) {
  if (!value) {
    return ''
  }

  const parsedValue = JSON.parse(value)
  const result = []
  const startDate = _get(parsedValue, 'start')
  if (startDate) {
    result.push(`Start Date: ${formatWrapped(new Date(startDate * 1000), dateTimeFormat)}`)
  }

  const endDate = _get(parsedValue, 'end')
  if (endDate) {
    result.push(`End Date: ${formatWrapped(new Date(endDate * 1000), dateTimeFormat)}`)
  }

  const contentSetId = _get(parsedValue, 'content_set_id')
  if (contentSetId) {
    const entitledTo = CONTENT_SET_LABELS[contentSetId] || `Offering ${contentSetId}`
    result.push(`Entitled to: ${entitledTo}`)
  }

  const ecommerceSku = _get(parsedValue, 'ecommerce_sku')
  if (ecommerceSku) {
    result.push(`Ecommerce SKU: ${ecommerceSku}`)
  }

  return result.join(', ')
}

function getFormattedDateInUTC (date) {
  if (!date) {
    return ''
  }
  const monthString = (date.getUTCMonth() + 1).toString().padStart(2, '0')
  return `${date.getUTCFullYear()}-${monthString}-${date.getUTCDate()}`
}
